export default {
  getTranslatedString(state, sourceLanguage, sourceText, targetLanguage) {
    const translateKey = `${sourceLanguage}-${sourceText}`

    return state.translatedStrings?.[translateKey]?.[targetLanguage] || null
  },
  getTranslatedStringLoading(state, sourceLanguage, sourceText) {
    const translateKey = `${sourceLanguage}-${sourceText}`

    return state.translatedStringLoading.includes(translateKey)
  },
}
